import { render, staticRenderFns } from "./BaseTLTableRest.vue?vue&type=template&id=5b7f5301&"
import script from "./BaseTLTableRest.vue?vue&type=script&lang=ts&"
export * from "./BaseTLTableRest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports